import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import Hero from './landing/Hero';
import HowItWorks from './landing/HowItWorks';
import Countries from './landing/Countries';
import Features from './landing/Features';
import Testimonials from './landing/Testimonials';
import FAQ from './landing/FAQ';
import Footer from './landing/Footer';
import StickyCtaBar from './landing/StickyCtaBar';
import ExitIntentModal from './landing/ExitIntentModal';
import { FadeUp, GRAD_TEXT } from './landing/shared';

const LandingPage = () => {
  const navigate = useNavigate();
  const goToUpload = () => navigate('/upload');

  return (
    <div style={{ minHeight: '100vh', background: 'linear-gradient(180deg, #FFEDDA 0%, #FFFFFF 60%)' }}>
      {/* ─── HEADER ─── */}
      <header style={{
        position: 'fixed', top: 0, left: 0, right: 0, zIndex: 50,
        background: 'rgba(255,253,250,0.85)',
        backdropFilter: 'blur(16px)', WebkitBackdropFilter: 'blur(16px)',
        borderBottom: '1px solid rgba(48,43,44,0.08)',
      }}>
        <div style={{
          maxWidth: '1024px', margin: '0 auto', padding: '0 1.5rem',
          display: 'flex', justifyContent: 'space-between', alignItems: 'center', height: '64px',
        }}>
          <div style={{ cursor: 'pointer' }} onClick={() => navigate('/')}>
            <img src="/axpats-logo.webp" alt="Axpats" style={{ height: '36px' }} data-testid="header-logo" />
          </div>
          <nav style={{ display: 'flex', gap: '0.75rem', alignItems: 'center' }}>
            <button onClick={goToUpload} data-testid="header-start-btn" style={{
              display: 'flex', alignItems: 'center', gap: '6px',
              background: 'linear-gradient(135deg, #F67425, #BB0518)', color: '#fff', border: 'none', borderRadius: '2px',
              padding: '10px 18px', fontFamily: 'var(--font-heading)', fontSize: '0.8125rem', fontWeight: 700,
              cursor: 'pointer', transition: 'transform 0.2s, box-shadow 0.3s', whiteSpace: 'nowrap',
              boxShadow: '0 2px 10px rgba(246,116,37,0.2)',
            }}
              onMouseEnter={e => { e.currentTarget.style.transform = 'scale(1.03)'; e.currentTarget.style.boxShadow = '0 8px 24px rgba(246,116,37,0.3)'; }}
              onMouseLeave={e => { e.currentTarget.style.transform = 'scale(1)'; e.currentTarget.style.boxShadow = '0 2px 10px rgba(246,116,37,0.2)'; }}
            >Start <ArrowRight size={16} /></button>
          </nav>
        </div>
      </header>

      <Hero onStart={goToUpload} />
      <HowItWorks onStart={goToUpload} />
      <Countries onStart={goToUpload} />
      <Features />
      <Testimonials onStart={goToUpload} />

      {/* ─── FINAL CTA ─── */}
      <section style={{ padding: '0 1.5rem 7rem', maxWidth: '900px', margin: '0 auto' }}>
        <FadeUp>
          <div style={{
            position: 'relative', overflow: 'hidden', borderRadius: '2px',
            border: '1px solid rgba(48,43,44,0.1)', background: '#fff',
            padding: '4.5rem 2.5rem', textAlign: 'center',
            boxShadow: '0 20px 50px -20px rgba(48,43,44,0.12)',
          }}>
            <div style={{
              position: 'absolute', top: '-30%', left: '50%', transform: 'translateX(-50%)',
              width: '600px', height: '400px',
              background: 'radial-gradient(circle, rgba(246,116,37,0.08) 0%, transparent 70%)',
            }} />
            <div style={{ position: 'relative', zIndex: 1 }}>
              <h2 style={{
                fontFamily: 'var(--font-heading)', fontSize: 'clamp(1.5rem, 4vw, 2.5rem)',
                fontWeight: 800, color: '#302B2C', letterSpacing: '-0.03em', lineHeight: 1.05, marginBottom: '1rem',
              }}>Your next chapter <span style={GRAD_TEXT}>starts here</span></h2>
              <p style={{
                fontFamily: 'var(--font-body)', fontSize: '1rem', color: 'rgba(48,43,44,0.72)',
                lineHeight: 1.7, maxWidth: '480px', margin: '0 auto 2rem',
              }}>
                Upload your CV, answer a few questions, and discover every country where you can build your future.
              </p>
              <button onClick={goToUpload} data-testid="cta-start-btn" style={{
                display: 'inline-flex', alignItems: 'center', gap: '10px', padding: '16px 36px',
                background: 'linear-gradient(135deg, #F67425, #BB0518)', color: '#fff', border: 'none', borderRadius: '2px',
                fontFamily: 'var(--font-heading)', fontSize: '1.0625rem', fontWeight: 700, cursor: 'pointer',
                boxShadow: '0 4px 16px rgba(246,116,37,0.25)', transition: 'transform 0.2s, box-shadow 0.3s',
              }}
                onMouseEnter={e => { e.currentTarget.style.transform = 'scale(1.03)'; e.currentTarget.style.boxShadow = '0 8px 24px rgba(246,116,37,0.3)'; }}
                onMouseLeave={e => { e.currentTarget.style.transform = 'scale(1)'; e.currentTarget.style.boxShadow = '0 4px 16px rgba(246,116,37,0.25)'; }}
              >Start My Assessment <ArrowRight size={18} /></button>
              <p style={{ fontFamily: 'var(--font-body)', fontSize: '0.7rem', fontWeight: 600, letterSpacing: '0.06em', color: 'rgba(48,43,44,0.5)', marginTop: '1rem' }}>Free assessment — takes under 5 minutes</p>
            </div>
          </div>
        </FadeUp>
      </section>

      <FAQ />

      <Footer />
      <StickyCtaBar onClick={goToUpload} />
      <ExitIntentModal onStart={goToUpload} />
    </div>
  );
};

export default LandingPage;
